'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _PopupPanel = require('../../../../components/popupPanel/PopupPanel');

var _PopupPanel2 = _interopRequireDefault(_PopupPanel);

var _AnchorButton = require('../../../../components/buttons/AnchorButton');

var _AnchorButton2 = _interopRequireDefault(_AnchorButton);

var _CountIndicator = require('../../../../components/misc/CountIndicator');

var _CountIndicator2 = _interopRequireDefault(_CountIndicator);

var _Icon = require('../../../../components/icons/Icon');

var _Icon2 = _interopRequireDefault(_Icon);

var _helpUtilSelector = require('./helpUtilSelector');

var _helpUtilSelector2 = _interopRequireDefault(_helpUtilSelector);

var _analyticsActions = require('../../../../analytics/analyticsActions');

var _popupActions = require('../../../../components/popupPanel/popupActions');

var _urlConstants = require('../../../../../common/utils/urlConstants');

require('./HelpPopup.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } // Lib


// Components


// Selector


// Actions


// Constants


var mapDispatchToProps = function mapDispatchToProps(dispatch) {
    return {
        handleFeedbackButtonClick: function handleFeedbackButtonClick() {
            dispatch((0, _popupActions.togglePopup)('help'));
            dispatch((0, _analyticsActions.intercomShowMessages)());
        }
    };
};

var HelpPopup = function HelpPopup(_ref) {
    var handleFeedbackButtonClick = _ref.handleFeedbackButtonClick,
        unreadMessageCount = _ref.unreadMessageCount,
        props = _objectWithoutProperties(_ref, ['handleFeedbackButtonClick', 'unreadMessageCount']);

    return _react2.default.createElement(
        _PopupPanel2.default,
        _extends({}, props, {
            popupId: 'help',
            className: 'HelpPopup' }),
        _react2.default.createElement(
            'ul',
            null,
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    _AnchorButton2.default,
                    { href: _urlConstants.HELP_URL, target: '_blank' },
                    _react2.default.createElement(
                        'div',
                        { className: 'icon icon-help-center' },
                        _react2.default.createElement(_Icon2.default, { name: 'help-center' })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'description' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            'Search our help centre'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'Read guides, articles & documents'
                        )
                    )
                )
            ),
            _react2.default.createElement(
                'li',
                null,
                _react2.default.createElement(
                    _AnchorButton2.default,
                    { onClickFn: handleFeedbackButtonClick },
                    _react2.default.createElement(
                        'div',
                        { className: 'icon' },
                        _react2.default.createElement('div', { className: 'chat-head' }),
                        _react2.default.createElement(_CountIndicator2.default, { count: unreadMessageCount, badge: true })
                    ),
                    _react2.default.createElement(
                        'div',
                        { className: 'description' },
                        _react2.default.createElement(
                            'h3',
                            null,
                            'Chat to a real person'
                        ),
                        _react2.default.createElement(
                            'p',
                            null,
                            'We\u2019ll respond in a few hours'
                        )
                    )
                )
            )
        )
    );
};

HelpPopup.propTypes = {
    unreadMessageCount: _propTypes2.default.number,
    handleFeedbackButtonClick: _propTypes2.default.func
};

exports.default = (0, _reactRedux.connect)(_helpUtilSelector2.default, mapDispatchToProps)(HelpPopup);


//////////////////
// WEBPACK FOOTER
// ./src/client/workspace/header/utils/help/HelpPopup.js
// module id = 2181
// module chunks = 0